var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophySolid = function SvgTrophySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    d: "M23.666 8.148v.084c0 1.004 0 1.507-.242 1.917-.241.411-.68.655-1.558 1.143l-.925.514c.637-2.156.85-4.473.929-6.454l.01-.258.003-.06c.76.263 1.187.46 1.453.829.33.458.33 1.067.33 2.285M.333 8.148v.084c0 1.004 0 1.507.242 1.917.241.411.68.655 1.558 1.143l.926.514c-.638-2.156-.85-4.473-.929-6.454l-.011-.258-.003-.061c-.76.264-1.187.46-1.453.83-.33.458-.33 1.067-.33 2.285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    fillRule: "evenodd",
    d: "M17.106 1.363A31 31 0 0 0 12 .958c-2.08 0-3.795.184-5.107.405-1.328.224-1.992.336-2.547 1.02s-.526 1.422-.467 2.9c.201 5.072 1.296 11.408 7.246 11.968v4.124H9.456c-.556 0-1.035.392-1.144.938l-.22 1.104H5a.875.875 0 1 0 0 1.75h14a.875.875 0 0 0 0-1.75h-3.092l-.22-1.104a1.17 1.17 0 0 0-1.145-.938h-1.668v-4.123c5.95-.56 7.045-6.897 7.246-11.97.059-1.477.088-2.216-.467-2.9s-1.22-.795-2.548-1.02",
    clipRule: "evenodd"
  })));
};
export default SvgTrophySolid;